import { SortByTypeEnum } from '../enums/sort-by.enum';
import { ISelectChoices } from '../interfaces/generic-select-config.interface';

export const enumToSelectChoices = (enumToTransform: any): ISelectChoices[] =>
    Object.keys(enumToTransform)
        .filter((e: any) => isNaN(Number(e)))
        .map((key: string) => ({ label: enumToTransform[key], value: enumToTransform[key] }));

export const numberFloat2Decimals = (num: number): number => +parseFloat(num.toString()).toFixed(2);

export const sortArray = (array: any[], key: string, direction: 'asc' | 'desc', type: SortByTypeEnum): any[] => {
    if (type === SortByTypeEnum.DATE) {
        return direction === 'asc'
            ? array.sort((a: any, b: any) => a[key].getTime() - b[key].getTime())
            : array.sort((a: any, b: any) => b[key].getTime() - a[key].getTime());
    } else if (type === SortByTypeEnum.NUMBER) {
        return direction === 'asc' ? array.sort((a: any, b: any) => a[key] - b[key]) : array.sort((a: any, b: any) => b[key] - a[key]);
    } else if (type === SortByTypeEnum.STRING) {
        return direction === 'asc'
            ? array.sort((a: any, b: any) => (a[key].toLowerCase() < b[key].toLowerCase() ? -1 : 1))
            : array.sort((a: any, b: any) => (b[key].toLowerCase() > a[key].toLowerCase() ? 1 : -1));
    } else {
        return array;
    }
};
